import * as THREE from 'three';
import Experience from '../Experience.js';
import Resources from '../Utils/Resources.js';
import { Sky } from 'three/examples/jsm/objects/Sky.js';

export default class Environment {
    constructor() {
        this.experience = Experience.getInstance();
        this.scene = this.experience.scene;
        this.debug = this.experience.debug;
        this.resources = Resources.getInstance();

        this.setAmbientLight();
        this.setDirectionalLight();
        // this.setSky();
        this.setEnvironmentMap();
    }

    setAmbientLight() {
        this.ambientLight = new THREE.AmbientLight('#ffffff', 1);
        this.scene.add(this.ambientLight);
    }

    setDirectionalLight() {
        this.directionalLight = new THREE.DirectionalLight('#ffffff', 3);
        this.directionalLight.castShadow = true;
        this.directionalLight.shadow.camera.far = 15;
        this.directionalLight.shadow.mapSize.set(1024, 1024);
        this.directionalLight.shadow.normalBias = 0.05;
        this.directionalLight.position.set(0.25, 2, - 2.25)
        this.scene.add(this.directionalLight);
    }

    setSky() {
        this.sky = new Sky();
        this.sky.scale.set(10000, 10000, 10000);
        this.scene.add(this.sky);

        this.sky.material.uniforms['turbidity'].value = 10;//10 // Moderate turbidity for an eerie diffused look
        this.sky.material.uniforms['rayleigh'].value = 0.3;//3 // Low rayleigh for a hazy, unsettling sky
        this.sky.material.uniforms['mieCoefficient'].value = 0.5;//0.1 // Low mie coefficient to reduce brightness
        this.sky.material.uniforms['mieDirectionalG'].value = 0.7;//0.95 // Makes the sky light more directional
        this.sky.material.uniforms['sunPosition'].value.set(0.3, -0.038, -0.95); // (-5000, -150, -1000)// Sun position is set low for a dusk-like effect
    }

    setEnvironmentMap() {
        this.environmentMap = {};
        this.environmentMap.intensity = 5;
        this.environmentMap.texture = this.resources.items.environmentMap;
        this.environmentMap.texture.mapping = THREE.EquirectangularReflectionMapping;
        this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace;

        this.scene.environment = this.environmentMap.texture;
        this.scene.background = this.environmentMap.texture;
    }
}